/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

export const MOBILE = "mobile";
export const PAGE_TITLE_FOR_MOBILE = "La Xarxa+";
export const DEFAULT_PATH_NAME = "home";
